import Layout from "../../layout/main";
import StackKit from "@/shared/components/kit/stack";
import Message from "../../components/message";
import { Outlet, useLocation } from "react-router";
/**
 * MessagePage
 *
 * صفحه پشتیبانی کاربران. در صورت مسیر دقیق "/message"، کامپوننت Support را نمایش می‌دهد و در غیر این صورت، Outlet برای مسیرهای فرزند رندر می‌شود.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد شما درست است و ساختار مناسبی برای رندر Support یا Outlet بر اساس مسیر دارد.
// نکته: اگر مسیرهای فرزند زیادی دارید، می‌توان بررسی مسیر را با useMatch ساده‌تر کرد.

const MessagePage = () => {
  const location = useLocation();

  const isExactCreditsPage = location.pathname === "/list-message";

  return (
    <Layout>
      <StackKit direction={"column"} sx={{width: "100%",maxWidth: "1740px",gap: 10,}}>
        {isExactCreditsPage ? <Message /> : <Outlet />}
      </StackKit>
    </Layout>
  );
};

export default MessagePage;
